import { Stack, Typography } from "@mui/material"
import { Frame } from "../../components/layouts/Frame"
import { DataTable } from "../../components/global/Table/DataTable"
import { DataTableHeadCellData } from "../../components/global/Table/DataTableHeader";
import { useEffect, useRef, useState } from "react";
import { useAPI } from "../../hooks/useAPI";
import { useAuth } from "../../assets/contexts/AuthContext";
import { TagData } from "../../types";
import { Link } from "../../components/global/Link";
import { EditIcon } from "../../assets/svgs/EditIcon";
import { ActiveIcon } from "../../assets/svgs/ActiveIcon";
import { DeactiveIcon } from "../../assets/svgs/DeactiveIcon";
import { Route, Routes } from "react-router-dom";
import { EditTagModal } from "./EditTagModal";

const headCells: DataTableHeadCellData[] = [
  {
    id: 'uuid',
    disablePadding: true,
    label: 'UUID',
    align: 'left',
    sortable: true,
  },
  {
    id: 'secure_tag',
    disablePadding: true,
    label: 'Secure Tag',
    align: 'left',
    sortable: true,
  },
  {
    id: 'client',
    disablePadding: false,
    label: 'Client',
  },
  {
    id: 'product',
    disablePadding: false,
    label: 'Product',
  },
  {
    id: 'active',
    disablePadding: false,
    label: 'Active',
    width: '50px',
  },
  {
    id: 'edit',
    disablePadding: false,
    label: 'Edit',
    width: '50px',
  },
];

interface TagsTableData {
  id: any;
  uuid: any;
  secure_tag: any;
  client: any;
  product: any;
  active: JSX.Element;
  edit: JSX.Element;
}

export const Tags = () => {
  const isLoading = useRef(false);
  const [sIsLoading, setSIsLoading] = useState(false);
  const { fetchData } = useAPI();
  const [rows, setRows] = useState<TagsTableData[]>([]);
  const [tags, setTags] = useState<TagData[]>([]);
  const { isAuthenticated } = useAuth();

  const refetchTags = async () => {
    setSIsLoading(true);
    isLoading.current = true;
    const {errors, data} = await fetchData('/tags/all');
    setTags(data ?? []);
    isLoading.current = false;
    setSIsLoading(false);
  }

  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      refetchTags();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    setRows(getRows(tags));
  }, [tags]);

  const getRows = (tags: TagData[]) => {
    const result: TagsTableData[] = [];
    for (let i=0; i<tags.length; i++) {
      result.push({
        id: `${tags[i].id}`,
        uuid: <Typography>{tags[i].uuid}</Typography>,
        secure_tag: <Typography>{tags[i].secure_tag}</Typography>,
        client: <Typography>{tags[i].client?.name ?? ''}</Typography>,
        product: <Typography>{tags[i].product?.name ?? ''}</Typography>,
        active: tags[i].status ? <ActiveIcon /> : <DeactiveIcon />,
        edit: <Link to={`/tags/${tags[i].id}`}><EditIcon /></Link>
      });
    }
    return result;
  }

  return (
    <Frame title="Tags" toolbarButtons={(
      <> </>
    )}>
      <Stack spacing={6}>
        <Routes>
          <Route
            path="/:tag_id/"
            element={<EditTagModal refetchTags={refetchTags} />}
          ></Route>
        </Routes>
        <Stack spacing={4}>
          <DataTable 
            title="Tags" 
            hideToolBar={true} 
            hideDeleteButton={true} 
            hideIdCheckbox={true} 
            headCells={headCells} 
            rows={rows} 
            isLoading={sIsLoading} 
          />
        </Stack>
      </Stack>
    </Frame>
  )
}
